export const LOADING_TEST_ID = 'loading'
